import CarouselSliderGaleria from "./CarouselSliderGaleria";

export default CarouselSliderGaleria;
